window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.mapboxgl = require('mapbox-gl');
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    window.sortable = require('jquery-ui/ui/widgets/sortable')
    require('bootstrap');
    window.moment = require('moment');
    let Chart = require('chart.js');
    require('bootstrap-datepicker');
    require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.nl.min.js');
    require('bootstrap-select');

    if ($.fn && $.fn.selectpicker && $.fn.selectpicker.Constructor) {
        const Selectpicker = $.fn.selectpicker.Constructor;
        const originalSetSize = Selectpicker.prototype.setSize;

        Selectpicker.prototype.setSize = function (refresh) {
            const data = this.selectpicker && this.selectpicker.current && this.selectpicker.current.data;
            if (data && data.length && !data.some((item) => item.type === 'option' && item.element)) {
                if (!this._selectpickerSetSizePending) {
                    this._selectpickerSetSizePending = true;
                    const instance = this;
                    setTimeout(() => {
                        instance._selectpickerSetSizePending = false;
                        originalSetSize.call(instance, true);
                    }, 0);
                }
                return;
            }
            originalSetSize.call(this, refresh);
        };
    }
    require('@noardcode/compass-side-panels');
    require('@noardcode/compass-tables');
    require('@noardcode/compass-forms');

} catch (e) {console.log(e)}

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

window.bootstrapDatepickerConfig ??= {
    dateFormat: 'dd-mm-yy',
    weekStart: 1,
    ignoreReadonly: true,
    orientation: 'auto',
    forceParse: false,
    todayBtn: true,
    todayHighlight: true,
    clearBtn: true,
    language: document.getElementsByTagName('html')[0].getAttribute('lang'),
    format: {
        /*
         * Say our UI should display a week ahead,
         * but textbox should store the actual date.
         * This is useful if we need UI to select local dates,
         * but store in UTC
         */
        toDisplay: function (date, format, language) {
            return moment(date).format('DD-MM-YYYY');
        },
        toValue: function (date, format, language) {
            return moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD');
        }
    }
}

$(function () {
    $('[data-toggle="tooltip"]').tooltip({
        container: 'body',
        boundary: 'window',
        fallbackPlacements: [],
        trigger: 'hover'
    });
    $('[data-tooltip]').tooltip()
    $('.datepicker').datepicker(bootstrapDatepickerConfig);
})
